import { UsageTableTitle } from "./UsageTableTitle";

interface UsageTableLgProps {
  data: any[];
}

const UsageTableLg = ({ data }: UsageTableLgProps) => {
  return (
    <table className="billing-table">
      <tbody>
        <UsageTableTitle />
        {data.length ? (
          data.map((item, index) => (
            <tr key={index}>
              <td>{item.modelName}</td>
              <td>
                <div>
                  <span>{item.tokens.paid}</span>
                  <span>{item.tokens.free}</span>
                </div>
              </td>
              <td>{item.costSavings}</td>
              <td>{item.totalCost}</td>
            </tr>
          ))
        ) : (
          <tr className="no-data-row">
            <td colSpan={4}>No data</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export { UsageTableLg };
